import type { ReactNode } from 'react'

import styles from './EmailConfirmationScreen.module.css'

export interface EmailConfirmationScreenProps {
  children?: ReactNode
  logoPrimary: string
  landingPageImage: string
}

export function EmailConfirmationScreen({
  children,
  logoPrimary,
  landingPageImage,
}: EmailConfirmationScreenProps) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={logoPrimary} alt="" />
        </div>
        <div>{children}</div>
        <div className={styles.copyright}>
          <div>Copyright &copy; Tickmark, Inc {new Date().getFullYear()}</div>
        </div>
      </div>
      <div className={styles.image}>
        <img src={landingPageImage} alt="A group of people around a laptop" />
      </div>
    </div>
  )
}
